export const PhoneIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33301 5.99992C3.33301 3.80003 3.33301 2.70009 4.01643 2.01667C4.69984 1.33325 5.79979 1.33325 7.99967 1.33325C10.1995 1.33325 11.2995 1.33325 11.9829 2.01667C12.6663 2.70009 12.6663 3.80003 12.6663 5.99992V9.99992C12.6663 12.1998 12.6663 13.2997 11.9829 13.9832C11.2995 14.6666 10.1995 14.6666 7.99967 14.6666C5.79979 14.6666 4.69984 14.6666 4.01643 13.9832C3.33301 13.2997 3.33301 12.1998 3.33301 9.99992V5.99992Z"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M7.33301 12.6667H8.66634"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 1.33325L6.05933 1.68927C6.18792 2.46078 6.25221 2.84654 6.51679 3.08128C6.7928 3.32615 7.18407 3.33325 8 3.33325C8.81593 3.33325 9.2072 3.32615 9.4832 3.08128C9.7478 2.84654 9.81207 2.46078 9.94067 1.68927L10 1.33325"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);
